// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonWordLimitViewer_root__11Kac"};